export default __webpack_public_path__ + "static/media/aggressionIcon.71e4217c.svg";